import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-4" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = { class: "col-md-4" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { class: "col-md-4" }
const _hoisted_9 = {
  key: 0,
  class: "card mb-25 border-0 rounded-0 bg-white letter-spacing mb-20"
}
const _hoisted_10 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_11 = { class: "d-sm-flex align-items-center" }
const _hoisted_12 = { class: "d-sm-flex align-items-center" }
const _hoisted_13 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_14 = {
  key: 0,
  class: "text-nowrap"
}
const _hoisted_15 = {
  key: 1,
  class: "text-nowrap"
}
const _hoisted_16 = {
  key: 2,
  class: "text-nowrap"
}
const _hoisted_17 = { key: 0 }
const _hoisted_18 = {
  key: 3,
  class: "text-nowrap"
}
const _hoisted_19 = {
  key: 4,
  class: "text-nowrap"
}
const _hoisted_20 = {
  key: 6,
  class: "dropdown"
}
const _hoisted_21 = { class: "dropdown-menu" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { key: 1 }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = ["onClick"]
const _hoisted_27 = ["onClick"]
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { key: 7 }
const _hoisted_30 = {
  class: "modal fade",
  id: "detailBonModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_31 = { class: "modal-dialog modal-dialog-centered modal-lg" }
const _hoisted_32 = { class: "modal-content p-15 p-md-40" }
const _hoisted_33 = { class: "modal-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_button = _resolveComponent("b-button")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_center = _resolveComponent("center")!
  const _component_vue_good_table = _resolveComponent("vue-good-table")!
  const _component_PaginatorContent = _resolveComponent("PaginatorContent")!
  const _component_details_note = _resolveComponent("details-note")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[9] || (_cache[9] = _createElementVNode("label", null, "Nom du magasin / Client :", -1)),
              _withDirectives(_createElementVNode("input", {
                class: "form-control",
                type: "text",
                id: "customer",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.customer) = $event))
              }, null, 512), [
                [_vModelText, _ctx.customer]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _cache[10] || (_cache[10] = _createElementVNode("label", null, "Votre Code :", -1)),
              _withDirectives(_createElementVNode("input", {
                class: "form-control",
                type: "text",
                id: "code",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.custcode) = $event))
              }, null, 512), [
                [_vModelText, _ctx.custcode]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_b_button, {
              style: {"margin-top":"22px"},
              variant: "primary",
              class: "mb-1 mb-sm-0 mr-0 mr-sm-1",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.filter()))
            }, {
              default: _withCtx(() => _cache[11] || (_cache[11] = [
                _createElementVNode("i", { class: "flaticon-search" }, null, -1),
                _createTextVNode(" Chercher ", -1)
              ])),
              _: 1,
              __: [11]
            }),
            _createVNode(_component_b_button, {
              style: {"margin-top":"22px"},
              variant: "danger",
              class: "mb-1 mb-sm-0 mr-0 mr-sm-1",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.removefilter()))
            }, {
              default: _withCtx(() => _cache[12] || (_cache[12] = [
                _createElementVNode("i", { class: "flaticon-close" }, null, -1),
                _createTextVNode(" Annuler ", -1)
              ])),
              _: 1,
              __: [12]
            })
          ])
        ])
      ])
    ]),
    (_ctx.showData)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _cache[13] || (_cache[13] = _createElementVNode("label", null, "Voir", -1)),
              _createVNode(_component_v_select, {
                modelValue: _ctx.filters.per_page,
                "onUpdate:modelValue": [
                  _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filters.per_page) = $event)),
                  _cache[5] || (_cache[5] = ($event: any) => (_ctx.getRecords()))
                ],
                options: [10, 25, 50, 100],
                clearable: false,
                class: "per-page-selector d-inline-block mx-50"
              }, null, 8, ["modelValue"]),
              _createElementVNode("label", null, "sur " + _toDisplayString(_ctx.filters.total) + " entités", 1)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control shadow-none text-black rounded-0",
                placeholder: "Chercher",
                onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.filter())),
                onInput: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.filters.searchTerm) = $event))
              }, null, 544), [
                [_vModelText, _ctx.filters.searchTerm]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_vue_good_table, {
              columns: _ctx.columns,
              rows: _ctx.rows,
              loading: _ctx.isLoader
            }, {
              emptystate: _withCtx(() => [
                _createVNode(_component_center, null, {
                  default: _withCtx(() => _cache[14] || (_cache[14] = [
                    _createTextVNode("Aucune entrées correspondantes trouvées", -1)
                  ])),
                  _: 1,
                  __: [14]
                })
              ]),
              "table-row": _withCtx((props) => [
                (props.column.field === 'note_ref')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                      _createElementVNode("b", null, _toDisplayString(props.row.note_ref), 1)
                    ]))
                  : (props.column.field === 'note_customer_name')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _createElementVNode("b", null, _toDisplayString(props.row.magasin_name), 1),
                        _cache[15] || (_cache[15] = _createElementVNode("br", null, null, -1)),
                        _createTextVNode(" (" + _toDisplayString(props.row.note_customer_name) + ") ", 1)
                      ]))
                    : (props.column.field === 'created_at')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                          (props.row.created_at != null)
                            ? (_openBlock(), _createElementBlock("h5", _hoisted_17, _toDisplayString(_ctx.getDate(props.row.created_at)), 1))
                            : _createCommentVNode("", true)
                        ]))
                      : (props.column.field === 'note_total_parcel')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_18, [
                            _createElementVNode("h5", null, _toDisplayString(props.row.note_total_parcel), 1)
                          ]))
                        : (props.column.field === 'note_total_crbt')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
                              _createElementVNode("h5", null, _toDisplayString(props.row.crbt) + " " + _toDisplayString(_ctx.$devis), 1)
                            ]))
                          : (props.column.field === 'note_saved')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                (props.row.note_saved == 0)
                                  ? (_openBlock(), _createElementBlock("span", {
                                      key: 0,
                                      class: _normalizeClass([`badge rounded-pill fs-13 text-bg-${_ctx.resolveUserStatusVariant(
                  props.row.note_saved
                )}`, "text-capitalize"])
                                    }, " Nouveau ", 2))
                                  : (_openBlock(), _createElementBlock("span", {
                                      key: 1,
                                      class: _normalizeClass([`badge rounded-pill fs-13 text-bg-${_ctx.resolveUserStatusVariant(
                  props.row.note_saved
                )}`, "text-capitalize"])
                                    }, " Enregistré ", 2))
                              ], 64))
                            : (props.column.field === 'action')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                  _cache[21] || (_cache[21] = _createElementVNode("button", {
                                    class: "dropdown-toggle card-dot-btn lh-1 position-relative top-4 bg-transparent border-0 shadow-none p-0 transition",
                                    type: "button",
                                    "data-bs-toggle": "dropdown",
                                    "aria-expanded": "false"
                                  }, [
                                    _createElementVNode("i", { class: "flaticon-dots" })
                                  ], -1)),
                                  _createElementVNode("ul", _hoisted_21, [
                                    (_ctx.auth.can('BL_EXT'))
                                      ? (_openBlock(), _createElementBlock("li", _hoisted_22, [
                                          _createElementVNode("a", {
                                            class: "dropdown-item d-flex align-items-center",
                                            href: "javascript:void(0);",
                                            onClick: ($event: any) => (_ctx.showDetailSuivi(props.row))
                                          }, _cache[16] || (_cache[16] = [
                                            _createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }, null, -1),
                                            _createTextVNode(" Détails ", -1)
                                          ]), 8, _hoisted_23)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (_ctx.auth.can('BL_EXT') && props.row.note_total_parcel == 0)
                                      ? (_openBlock(), _createElementBlock("li", _hoisted_24, [
                                          _createElementVNode("a", {
                                            class: "dropdown-item d-flex align-items-center",
                                            href: "javascript:void(0);",
                                            onClick: ($event: any) => (_ctx.removeBL(props.row.id))
                                          }, _cache[17] || (_cache[17] = [
                                            _createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }, null, -1),
                                            _createTextVNode(" Supprimer ", -1)
                                          ]), 8, _hoisted_25)
                                        ]))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("li", null, [
                                      (_ctx.auth.can('BL_EXT') && props.row.note_total_parcel != 0)
                                        ? (_openBlock(), _createElementBlock("a", {
                                            key: 0,
                                            class: "dropdown-item d-flex align-items-center",
                                            href: "javascript:void(0);",
                                            onClick: ($event: any) => (_ctx.getPDF(props.row))
                                          }, _cache[18] || (_cache[18] = [
                                            _createElementVNode("i", { class: "flaticon-printer lh-1 me-8 position-relative top-1" }, null, -1),
                                            _createTextVNode(" PDF ", -1)
                                          ]), 8, _hoisted_26))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("li", null, [
                                      (_ctx.auth.can('BL_EXT') && props.row.note_total_parcel != 0)
                                        ? (_openBlock(), _createElementBlock("a", {
                                            key: 0,
                                            class: "dropdown-item d-flex align-items-center",
                                            href: "javascript:void(0);",
                                            onClick: ($event: any) => (_ctx.ticketsPDF(props.row))
                                          }, _cache[19] || (_cache[19] = [
                                            _createElementVNode("i", { class: "flaticon-menu lh-1 me-8 position-relative top-1" }, null, -1),
                                            _createTextVNode(" PDF ", -1)
                                          ]), 8, _hoisted_27))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("li", null, [
                                      (_ctx.auth.can('BL_EXT') && props.row.note_total_parcel != 0)
                                        ? (_openBlock(), _createElementBlock("a", {
                                            key: 0,
                                            class: "dropdown-item d-flex align-items-center",
                                            href: "javascript:void(0);",
                                            onClick: ($event: any) => (_ctx.tickets4PDF(props.row))
                                          }, _cache[20] || (_cache[20] = [
                                            _createElementVNode("i", { class: "flaticon-more-1 lh-1 me-8 position-relative top-1" }, null, -1),
                                            _createTextVNode(" PDF ", -1)
                                          ]), 8, _hoisted_28))
                                        : _createCommentVNode("", true)
                                    ])
                                  ])
                                ]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(props.formattedRow[props.column.field]), 1))
              ]),
              _: 1
            }, 8, ["columns", "rows", "loading"]),
            _createVNode(_component_PaginatorContent, {
              pagination: _ctx.filters,
              offset: 9,
              onPaginate: _ctx.getRecords
            }, null, 8, ["pagination", "onPaginate"])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_30, [
      _createElementVNode("div", _hoisted_31, [
        _createElementVNode("div", _hoisted_32, [
          _cache[22] || (_cache[22] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h1", { class: "modal-title fs-5" }, "Informations colis"),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_33, [
            _createVNode(_component_details_note, {
              noteBL: _ctx.noteBL,
              getRecords: _ctx.getRecords,
              type: true
            }, null, 8, ["noteBL", "getRecords"])
          ])
        ])
      ])
    ])
  ], 64))
}